import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Product} from '../../model/Entities/Product';
import {ProductService} from '../../services/product.service';
import {ProductType} from '../../model/Entities/ProductType';
import {DialogService} from '../../services/dialog.service';
import {ProductFileAddDialogComponent} from '../ProductFileAddDialogComponent/product-file-add.dialog.component';
import {SnackService} from '../../services/snack.service';
import {ProductFile} from '../../model/Entities/ProductFile';
import {ProductFileService} from '../../services/product-file.service';
import {Filter} from '../../model/Helpers/Filter';
import {ProductContent} from '../../model/Entities/ProductContent';
import {ProductContentService} from '../../services/product-content.service';
import {Customer} from '../../model/Entities/Customer';
import {BarcodeService} from '../../services/barcode.service';
import {Contract} from '../../model/Entities/Contract';
import {ContractItemsTransferDialogComponent} from '../../ContractsModule/ContractItemsTransferDialogComponent/contract-items-transfer.dialog.component';
import {ProductTransferDialogComponent} from '../ProductTransferDialogComponent/product-transfer.dialog.component';
import {environment} from '../../environments/environment';
import {ProductTransfersListComponent} from '../ProductTransfersListComponent/product-transfers-list.component';

@Component({
    selector: 'product-detail',
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {
    readonly productTypeClass: any = ProductType;

    product: Product;
    productFiles: ProductFile[] = [];
    private imageBaseHref: string = '';

    productTransfersList: ProductTransfersListComponent;

    @ViewChild('productTransfersList') set productTransfersListSetter(component: ProductTransfersListComponent) {
        this.productTransfersList = component;
    }

    constructor(private route: ActivatedRoute,
                private productService: ProductService,
                private productContentService: ProductContentService,
                private productFileService: ProductFileService,
                private dialogService: DialogService,
                public barcodeService: BarcodeService,
                private snackService: SnackService,
                private router: Router) {
    }

    ngOnInit(): void {
        const id = +this.route.snapshot.paramMap.get('id');
        this.product = new Product();
        this.imageBaseHref = this.productFileService.getImagesBaseUrl();

        this.loadProduct(id);
    }

    public openTransferDialog(direction: any): void {
        this.dialogService.showDialog(ProductTransferDialogComponent, {
            'product': this.product,
            'direction': direction
        }, 400).afterClosed().subscribe((result: any) => {
            if (!result) {
                return;
            }

            this.loadProduct(this.product.id);
            if (this.productTransfersList) {
                this.productTransfersList.reloadPage();
            }
            if (direction === ProductTransferDialogComponent.DIRECTION_IN) {
                this.snackService.showSuccess(`Zboží ${this.product.name} bylo naskladněno`);
            } else {
                this.snackService.showSuccess(`Zboží ${this.product.name} bylo vyskladněno`);
            }
        });
    }

    public addFile(): void {
        this.dialogService.showDialog(ProductFileAddDialogComponent, {
            productId: this.product.id
        }).afterClosed().subscribe((result) => {
            if (result) {
                this.loadFiles();
                this.snackService.showSuccess(`Obrázek byl přidán`);
            }
        });
    }

    public cloneProduct(): void {
        this.productService.clone(this.product.id, {name: `${this.product.name} - kopie`}).subscribe((newProduct: Product) => {
            this.snackService.showSuccess(`Kopie produktu byla vytvořena`);
            this.router.navigate([`/product/${newProduct.id}/edit`]);
        });
    }

    private loadProduct(id: Number): void {
        this.productService.get(id, {expand: 'payment_type,category,count'}).subscribe((product: Product) => {
            this.product = product;

            this.loadFiles();
        });
    }

    private loadFiles(): void {
        this.productFileService.getSimpleList([
            new Filter('product_id', this.product.id)
        ], {expand: 'file'}).subscribe((files: ProductFile[]) => {
            this.productFiles = files;

            if (this.product.type === ProductType.group) {
                this.loadProductContent();
            }
        });
    }

    private deleteFile(file: ProductFile): void {
        this.productFiles.splice(this.productFiles.indexOf(file), 1);
        this.productFileService.delete(file.id).subscribe(() => {
            this.snackService.showSuccess('Obrázek byl smazán');
        });
    }

    private loadProductContent(): void {
        this.productContentService.getSimpleList([
            new Filter('product_id', this.product.id)
        ], {expand: 'content'})
            .subscribe((contents: ProductContent[]) => {
                contents.forEach((c: ProductContent) => {
                    this.product.content.push(c);
                });
                // this.cdr.detectChanges();
            });
    }

    private gotoProduct(p: Product): void {
        this.product = new Product();
        this.loadProduct(p.id);
        // this.router.navigate([`/product/${p.id}`]);
    }

    showEshopProduct() {
        const url = environment.eshopAdmin + '/#/products/' + this.product.eshopExportId;
        window.open(url, "_blank");
    }

    manualSync() {
        // změnit stav produktu na "čeká na synchronizaci"
        this.product.eshopQueue = 'waiting';
        this.productService.update(this.product.id, this.product).subscribe(() => {
            this.snackService.showSuccess('Produkt manualně zařazen do fronty.');
        });
    }
}



// WEBPACK FOOTER //
// /app/src/ProductsModule/ProductDetailComponent/product-detail.component.ts